export default __webpack_public_path__ + "/425432__trivialaccapella__18-crash-hit-soft.mp3";